import $ from 'jquery';
import { component as defineComponent } from 'flightjs';
import withUploader from 'app/modules/mixins/with-uploader';

import '@99designs/asimov/modal';

export default defineComponent(function() {
    this.item = function(id) {
        return this.list().find('.uploader__item[data-id="' + id + '"]');
    };

    this.removeLogo = function(id) {
        this.item(id).remove();
        this.trigger('formChanged');
    };

    this.constructItem = function(data) {
        var $container = $(this.$node.data('uploader-template'));

        $container
            .attr('data-id', data.id)
            .addClass('uploader__item--success')
            .append($(this.prototype()));

        $container.find('[name*="[id]"]').val(data.id);
        $container.find('.uploader__thumb').css('background-image', 'url(' + data.thumbnail + ')');

        return $container;
    };

    this.addLogo = function($container) {
        this.list().append($container);
        this.attr.counter++;
        this.trigger('formChanged');
    };

    this.onSampleSelectionChange = function(ev, data) {
        if (data.checked) {
            this.addLogo(this.constructItem(data));
        } else {
            this.removeLogo(data.id);
        }
    };

    this.logoIds = function() {
        return this.list()
            .children()
            .map(function() {
                return $(this).data('id');
            })
            .get();
    };

    this.after('initialize', function() {
        this.trigger('updateSampleLogoRequested', {
            logos: this.logoIds(),
        });

        this.on('sampleSelectionChange', this.onSampleSelectionChange);
    });
}, withUploader);



// WEBPACK FOOTER //
// ./src/web/js/app/modules/logo-uploader.js